import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import type { PrivateProps as OptionProps } from 'modules/employees/components/Selector/Option/index'

export interface Props {
  value: unknown[]
  children: Array<React.ReactElement<OptionProps>>
  onChange: (value: unknown[] | unknown | null) => void
  filteredChildren: Array<React.ReactElement<OptionProps>>
}

const Container: React.FC<Props> = ({ value, filteredChildren, onChange }) => {
  const handleChange = (change: unknown) => {
    const nextValue = change === value[0] ? null : change

    onChange(nextValue)
  }

  const options = React.Children.map<React.ReactNode, React.ReactElement<OptionProps>>(
    filteredChildren,
    (x) => {
      const optionValue = x.props.value as string
      const isChecked = value.includes(optionValue)

      const onChange = () => {
        handleChange(optionValue)
      }

      return React.cloneElement(x, { onChange, isChecked })
    }
  )

  return (
    <Box overflowX="hidden" overflowY="scroll" width="full" style={{ maxHeight: '308px' }}>
      {options}
    </Box>
  )
}

export default Container
